import axios from "~/plugins/axios";

const baseUrl = "/web_api/v1/policy";

export default {
  initialCreateOrEditPageData(customerId, includes = []) {
    return axios.get(`/web_api/v1/policy/create_or_edit_page/${customerId}`, {
      params: {
        include: includes,
      },
    }).then((response) => response.data);
  },
  initializePackageData(packageId, includes = []) {
    return axios.get(`/web_api/v1/policy/edit_package_page/package/${packageId}`, {
      params: {
        include: includes,
      },
    }).then((response) => response.data);
  },
  getByCustomerId(customerId, includes = []) {
    return axios.get(`/web_api/v1/policy/by_customer/${customerId}`, {
      params: {
        include: includes,
      },
    }).then((response) => response.data);
  },

  getById(policyId) {
    return axios.get(`/web_api/v1/policy/${policyId}`).then((response) => response.data);
  },

  detailedSearch(query, secondQuery, type, limit, includes = []) {
    return axios.post("/web_api/v1/policy/detailed_search", {
      query,
      second_query: secondQuery,
      type,
      limit
    }, { params: { include: includes } })
      .then((response) => response.data);
  },

  getDescriptionsById(policyId) {
    return axios.get(`/web_api/v1/policy/${policyId}/descriptions/`).then((response) => response.data);
  },

  getStatusById(policyId) {
    return axios.get(`/web_api/v1/policy/status_by_id/${policyId}`).then((response) => response.data);
  },

  getPolicyPage(customerId, filter, include) {
    return axios.post(`/web_api/v1/policy/policy_page/${customerId}`, {
      filter,
      include,
    }).then((response) => response.data);
  },
  createPackagePage(customerId) {
    return axios.get(`/web_api/v1/policy/create_package_page/${customerId}`).then((response) => response.data);
  },
  getInitialPolicyShowPageData(policyId, include = []) {
    return axios.get(`/web_api/v1/policy/policy_show_page/${policyId}`, {
      params: {
        include,
      },
    }).then((response) => response.data);
  },
  storePolicy(form, customerId, packageId) {
    return axios.post(`/web_api/v1/policy/create/customer/${customerId}/package/${packageId}`, form)
      .then((response) => response.data);
  },
  storeSinglePolicy(form, customerId) {
    return axios.post(`/web_api/v1/policy/createSingle/customer/${customerId}`, form).then((response) => response.data);
  },
  updatePolicy(form, policyId) {
    return axios.put(`/web_api/v1/policy/${policyId}/update`, form).then((response) => response.data);
  },
  createPolicyPage(customerId, packageId = "", include) {
    return axios.get(`/web_api/v1/policy/create_page/customer/${customerId}/package/${packageId}`, {
      include,
    }).then((response) => response.data);
  },
  getViewGroups(customerId, brancheId) {
    return axios.get(`/web_api/v1/policy/view/groups/customer/${customerId}/branche/${brancheId}`)
      .then((response) => response.data);
  },
  getViewOptions(policyViewGroupid) {
    return axios.get(`/web_api/v1/policy/viewOptions/${policyViewGroupid}`).then((response) => response.data);
  },

  getViews(customerId, viewGroupId, policyViewId = []) {
    const include = [
      "views_grouped_by_entity.data_catalogs",
      "policy",
    ];
    return axios.post(`/web_api/v1/policy/customer/${customerId}/views`, {
      policy_view_id: policyViewId,
      view_group_id: viewGroupId,
      include,
    }).then((response) => response.data);
  },
  getViewsForEdit(customerId, policyId, viewGroupId, policyViewId = []) {
    return axios.post(`/web_api/v1/policy/customer/${customerId}/views_for_edit/policy/${policyId}`, {
      policy_view_id: policyViewId,
      view_group_id: viewGroupId,
    }).then((response) => response.data);
  },

  editPolicy(policyId, customerId, packageId) {
    const include = [
      "policy.view_group.required_views",
      "policy.view_group.views",
      "package",
    ];
    return axios.get(`/web_api/v1/policy/${policyId}/edit/customer/${customerId}/package/${packageId}`,
      {
        params: {
          include,
        },
      })
      .then((response) => response.data);
  },
  editSinglePolicy(policyId, customerId) {
    const include = [
      "policy.view_group.required_views",
      "policy.view_group.views",
    ];
    return axios.get(`/web_api/v1/policy/${policyId}/edit/customer/${customerId}`, {
      params: {
        include,
      },
    })
      .then((response) => response.data);
  },
  premiumMatricesByNumber(number) {
    return axios.get(`/web_api/v1/policy/premium_matrix/${number}`).then((response) => response.data);
  },
  getFilterOptions() {
    return axios.get("/web_api/v1/policy/filter/options").then((response) => response.data);
  },
  deletePolicy(customerId, policyId) {
    return axios.delete(`/web_api/v1/policy/${policyId}`)
      .then((response) => response.data);
  },

  getPoliciesByFilter(filter) {
    return axios.get(`${baseUrl}/filter`, {
      params: filter,
    }).then((response) => response.data);
  },

  getBranches() {
    return axios.get(`${baseUrl}/branches`).then((response) => response.data);
  },

  // TODO when merging Staging, refactor the routes in staging matching this pattern
  getViewGroupByBranch(brancheId) {
    return axios.get(`${baseUrl}/view_group/by_branche/${brancheId}`)
      .then((response) => response.data);
  },
};
